import api from '../..'

export interface JoinSessionBlockResponse {
  sessionPosition: number
  joinedAt: string
  blockSessionId: number
}

export const joinSessionBlock = (
  blockId: number,
  sessionPosition: number
): Promise<JoinSessionBlockResponse> => {
  return api
    .post(`block_session/block_instances/${blockId}/join`, {
      session_position: sessionPosition,
    })
    .then(({ data: { data } }) => ({
      sessionPosition: data.session_position ?? data.sessionPosition,
      joinedAt: data.joined_at ?? data.joinedAt,
      blockSessionId: data.block_session_id ?? data.blockSessionId,
    }))
}
